import {
  GamoraConstructorType,
  GamoraFoundationNode,
  GamoraFoundationNodeArgs,
  debugCreate,
  debugEnableAllLogging,
} from '@ver.id/libs.internal.gamora';
import {
  HoruzProtocolNode,
  HoruzProtocolNodeArgs,
} from './protocols/protocol.js';
import { HoruzQueueNode, HoruzQueueNodeArgs } from './queues/queue.js';
const debug = debugCreate({ namespace: 'horuz' });

/**
 * Root interface
 * @public
 */
export type IHoruz = GamoraFoundationNode<HoruzChildrenMap, IHoruz>;

/**
 * Children map
 * @public
 */
export interface HoruzChildrenMap {
  protocols: GamoraConstructorType<
    HoruzProtocolNode<IHoruz>,
    HoruzProtocolNodeArgs<IHoruz>
  >;
  queues: GamoraConstructorType<
    HoruzQueueNode<IHoruz>,
    HoruzQueueNodeArgs<IHoruz>
  >;
}

/**
 * Args
 * @public
 */
export interface HoruzArgs extends GamoraFoundationNodeArgs {
  protocols?: HoruzProtocolNodeArgs<IHoruz>;
  queues?: HoruzQueueNodeArgs<IHoruz>;
}

/**
 * Application
 * @public
 */
export class Horuz
  extends GamoraFoundationNode<HoruzChildrenMap>
  implements IHoruz
{
  /**
   * Constructor
   */
  constructor(args: HoruzArgs = {}) {
    // Enable specific logging messages
    debugEnableAllLogging();

    // Super
    super({
      childMap: {
        protocols: [HoruzProtocolNode, args.protocols ?? {}],
        queues: [HoruzQueueNode, args.queues ?? {}],
      },
    });

    // Initialize
    this._initialize();

    // Start strand
    this.$strand.start();
  }

  /**
   * Initialize
   */
  private _initialize() {
    this.$strand
      .post(async () => {
        debug.log('(_initialize): Initialized framework.');
      })
      .catch((e) => {
        debug.trace(
          '(_initialize): Unable to initialize framework: ' + e?.message,
          e?.stack,
        );
        console.log(e);
        process.exit(1);
      });
  }
}
